export default {
  name: 'PublicSidePanel',
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      default: 'publicSidePanel',
    },
    eyebrow: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      required: true,
    },
    closeLabel: {
      type: String,
      default: null,
    },
    showBackdrop: {
      type: Boolean,
      default: false,
    },
    closeOnBackdrop: {
      type: Boolean,
      default: true,
    },
    topOffset: {
      type: String,
      default: '66px',
    },
    shrinkTopOffset: {
      type: String,
      default: '58px',
    },
    shrinkScrollY: {
      type: Number,
      default: 20,
    },
    bottomOffset: {
      type: String,
      default: '22px',
    },
    width: {
      type: String,
      default: '430px',
    },
  },
  emits: ['update:modelValue', 'close'],
  data() {
    return {
      isShrunk: false,
    };
  },
  computed: {
    resolvedCloseLabel() {
      return this.closeLabel || this.$t('common.close');
    },
    titleId() {
      return `${this.id}Label`;
    },
    currentTopOffset() {
      return this.isShrunk ? this.shrinkTopOffset : this.topOffset;
    },
    panelStyle() {
      return {
        '--public-side-panel-top': this.currentTopOffset,
        '--public-side-panel-bottom': this.bottomOffset,
        '--public-side-panel-width': this.width,
      };
    },
  },
  watch: {
    modelValue(isOpen) {
      if (!isOpen) return;

      this.$nextTick(() => {
        this.$refs.panel?.focus?.();
      });
    },
  },
  mounted() {
    this.syncShrinkState();
    window.addEventListener('scroll', this.syncShrinkState, { passive: true });
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.syncShrinkState);
  },
  methods: {
    syncShrinkState() {
      this.isShrunk = window.scrollY > this.shrinkScrollY;
    },
    close() {
      this.$emit('update:modelValue', false);
      this.$emit('close');
    },
    handleBackdropClick() {
      if (this.closeOnBackdrop) this.close();
    },
  },
};
